import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

/**
 * Validator to check for invalid external tags, or those that have been selectively
 * excluded from a particular field
 * @param min
 */
export function minValidator(min: any): ValidatorFn {
    return (abstractControl: AbstractControl): ValidationErrors | null => {
        if (min) {
            if (abstractControl.value < min) {
                return {min: 'The value is less than ' + min};
            } else {
                return null;
            }
        } else {
            return null;
        }
    };
}
